const booleanValues = [{
  value: true,
  label: 'Ja',
}, {
  value: false,
  label: 'Nej',
}];

export default booleanValues;



// WEBPACK FOOTER //
// ./src/booleanValues.js